import { useAppState } from 'AppContextProvider'
import ReinforcementScreenContainer from 'Components/ReinforcementScreen/ReinforcementMain'
import { FC, useMemo } from 'react'
import { Trans } from 'react-i18next'
import { ReinforcementDescriptionHighlight, ReinforcementTitleHighlight } from '../Typography'
import { ReinforcementScreenBackgrounds, ReinforcementScreenContent } from 'types/reinforcementScreenTypes'
import { images } from 'images'

const stepImages: ReinforcementScreenBackgrounds<'1Or2' | '3Or4'> = {
  m: {
    '1Or2': images.outOfBreathInfoMale1Or2,
    '3Or4': images.outOfBreathInfoMale3Or4
  },
  f: {
    '1Or2': images.outOfBreathInfoFemale1Or2,
    '3Or4': images.outOfBreathInfoFemale3Or4
  }
}

interface OutOfBreathInfoScreenProps {
  onContinue: (shouldSkipNext?: boolean) => Promise<void>
}

const OutOfBreathInfoScreen: FC<OutOfBreathInfoScreenProps> = ({ onContinue }) => {
  const { appState } = useAppState()

  const screenContent = useMemo((): ReinforcementScreenContent => {
    const { gender = 'f', out_of_breath: outOfBreath } = appState.selections ?? {}
    const genderKey = (gender === 'o' ? 'f' : gender) as IGender
    const staminaStatus = ['cant_talk', 'can_talk'].includes(outOfBreath) ? '1Or2' : '3Or4'
    return {
      localePrefix: `reinforcementScreens.out_of_breath_info.${genderKey}.${staminaStatus}`,
      backgroundImagePath: stepImages[genderKey]![staminaStatus]
    }
  }, [appState.selections?.out_of_breath, appState.selections?.gender])

  return (
    <ReinforcementScreenContainer
      title={
        <Trans
          i18nKey={`${screenContent.localePrefix}.title`}
          components={{ em: <ReinforcementTitleHighlight /> }}
        />
      }
      description={
        <Trans
          i18nKey={`${screenContent.localePrefix}.body`}
          components={{ em: <ReinforcementDescriptionHighlight /> }}
        />
      }
      backgroundImage={screenContent.backgroundImagePath}
      onContinue={onContinue}
    />
  )
}

export default OutOfBreathInfoScreen
